'use client';
import React, {forwardRef, useEffect} from 'react';
import styles from './styles';
import MuiToggleButton from '@mui/material/ToggleButton';
import MuiToggleButtonGroup from '@mui/material/ToggleButtonGroup';

interface CheckItemProps {
  label: string;
  value: string;
}

const CheckItem: React.FC<CheckItemProps> = (props) => {
  return (
    <MuiToggleButton
      data-id={props.value}
      aria-label={props.label}
      value={props.value}
      sx={styles.checkButton}>
      {props.label}
    </MuiToggleButton>
  );
};

export interface HorizontalCheckInputProps {
  options: Omit<CheckItemProps, 'onToggle' | 'checked'>[];
  checkedOptions?: string[];
  onSelectionChange?: (selection: string[]) => void;
  enableReset?: boolean;
}

const NumericMultiCheckButton = forwardRef<
  HTMLDivElement,
  HorizontalCheckInputProps
>((props, ref) => {
  const [selection, setSelection] = React.useState(props.checkedOptions || []);
  const options = React.useMemo(() => {
    return [{label: 'Any', value: 'any'}, ...props.options];
  }, [props.options]);

  useEffect(() => {
    setSelection(props.checkedOptions || []);
  }, [props.checkedOptions]);

  const handleSelectionChange = (
    event: React.MouseEvent<HTMLElement>,
    newSelection: string[]
  ) => {
    let currentSelection = newSelection;

    if ((!selection.includes('any') && selection.length) && newSelection.includes('any')) {
      currentSelection = [];
    } else {
      currentSelection = newSelection.filter((item) => item !== 'any');
    }
    setSelection(currentSelection);
    if (props.onSelectionChange) {
      props.onSelectionChange(currentSelection);
    }
  };
  const selectedOptions = React.useMemo(() => {
    if (selection.length === 0) {
      return ['any'];
    }
    return selection;
  }, [selection]);

  return (
    <>
      <MuiToggleButtonGroup
        ref={ref}
        sx={styles.checkButtonWrapper}
        value={selectedOptions}
        onChange={handleSelectionChange}>
        {options.map((option) => (
          <CheckItem {...option} key={option.value} />
        ))}
      </MuiToggleButtonGroup>
    </>
  );
});

export default NumericMultiCheckButton;
